/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { Location } from '@reach/router'

import Layout from '../components/common/layout/layout'
import SEO from '../components/common/layout/seo'
import Navigation from '../components/common/navigation/navigation'

import Header from '../components/sections/header'
import GetStarted from '../components/sections/getstarted'
import Footer from '../components/sections/footer'

const IndexPage = () => (
  <Location>
    {locationProps => (
      <Layout>
        <SEO />
        <Navigation {...locationProps} />
        <Header />
        <GetStarted />
        <Footer />
      </Layout>
    )}
  </Location>
)

export default IndexPage
